// MainPage.js
import React, { useState } from 'react';
import './centro_quiropractico.css'; // Add custom styles for the main content
import EmbeddedMap from '../../tools/google_map'
import { useTranslation } from 'react-i18next';

const CentroQuiropractico = () => {
    const { t, i18n } = useTranslation('centro_quiropractico');

    return (
        <main className="center-content">
            {/* Main Section */}
            <section className="center">
                <div className="center__image">
                    <img src={`${process.env.PUBLIC_URL}/images/centro.jpg`} alt="logo" />
                </div>
            </section>

            { /* Map Section */}
            <section className="map">
                <div className="map__tittle"><span>Fuengirola</span></div>
                <div className="map__text"><span>{t('fuengirola_text')}</span></div>
                < EmbeddedMap coords={{ lat: 36.5471424, lng: -4.6242004 }} /> 

                <div className="map__tittle"><span>Málaga</span></div>
                <div className="map__text"><span>{t('malaga_text')}</span></div>
                < EmbeddedMap location={'C/ Fernando Camino 11, 1 A'} />
                 
            </section>

            { /* info section */}
            <section className="info">
                <div className="info__box">
                    <div className="info__box__tittle">
                        <img src={`${process.env.PUBLIC_URL}/images/reloj-de-pared.png`} alt="logo" ></img>
                        <span>{t('horario')}</span>
                    </div>

                    <div className="info__box__text">
                        <span>{t('horario_1')}</span>
                        <span>{t('horario_2')}</span>
                    </div>
                </div>

                <div className="info__box">
                    <div className="info__box__tittle">
                        <img src={`${process.env.PUBLIC_URL}/images/phone.png`} alt="logo" ></img>
                        <span>{t('contacto')}</span>
                    </div>

                    <div className="info__box__text">
                        <span>{t('contacto_1')}</span>
                        <span>{t('contacto_2')}</span>
                        <span>{t('contacto_3')}</span>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default CentroQuiropractico;
